<section>
  <kendo-grid [data]="newsAdminGridView"
              [height]="470"
              [sortable]="true"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="false"
              [sort]="newsGridstate.sort"
              (sortChange)="newsGridSortChange($event)"
              [pageable]="{ buttonCount: 5, info: true }"
              [pageSize]="newsGridstate.take"
              [skip]="newsGridstate.skip"
              [columnMenu]="false"
              (pageChange)="newsGridPageChange($event)"
              (dataStateChange)="newsDataStateChange($event)"
              [filter]="newsGridstate.filter"
              [loading]="newsLoading">


    <kendo-grid-column field="docGroupingAlias" title="{{news.groupLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="docCategoryDesc" title="{{news.categoryLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="docSubCategoryDesc" title="{{news.subCategoryLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="docDesc" title="Description" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <!--<kendo-grid-column field="pathName" title="{{news.filePathLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>-->
    <kendo-grid-column field="partNo" title="{{news.authorLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="revision" title="{{news.mailNoLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-command-column title="{{news.isActiveLbl}}" [width]="80" field="active">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch (click)="updateNewsGridDetails(dataItem)" [(ngModel)]="dataItem.active" [onLabel]="'Yes'"
                      [offLabel]="'No'">
        </kendo-switch>
      </ng-template>
    </kendo-grid-command-column>

    <kendo-grid-command-column title="{{news.actionLbl}}" [width]="80" field="">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem)">
          <span class="k-icon k-i-trash">
          </span>
        </button>

      </ng-template>
    </kendo-grid-command-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>
  </kendo-grid>
  <div class="col-sm-12 center">
    <button (click)="toggleNewsDialog()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
      {{news.addNewsLbl}}
    </button>&nbsp;

  </div>
</section>
<section class="dialogSection">
  <kendo-dialog title="Add News" *ngIf="newsDialog.opened" (close)="toggleNewsDialog()">
    <form [formGroup]="newsForm" style="max-height: 450px">
      <div class="row">
        <input type="hidden" formControlName="newsId" />
        <div class="col-sm-12">
          <div class="form-group">
            <label class="lblCls">
              {{news.groupLbl}}
            </label>
            <kendo-dropdownlist class="kendoInput" formControlName="group" [data]="groupData"
                                textField="docGroupingAlias" valueField="docGroupingID" (selectionChange)="groupChange($event)"
                                [ngClass]="{'borderRed':news.isEmptyGroup && news.isSubmitted}"
                                (blur)="validateNewsForm()">
            </kendo-dropdownlist>
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{news.categoryLbl}}
            </label>
            <kendo-dropdownlist class="kendoInput" formControlName="category" [data]="categoryData"
                                textField="docCategoryDesc" valueField="docCategoryID" (selectionChange)="categoryChange($event)"
                                [ngClass]="{'borderRed':news.isEmptyCategory && news.isSubmitted}"
                                (blur)="validateNewsForm()">
            </kendo-dropdownlist>
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{news.subCategoryLbl}}
            </label>
            <kendo-dropdownlist class="kendoInput" formControlName="subCategory"
                                [data]="subCategoryData"
                                textField="docSubCategoryDesc" valueField="docSubCategoryID"
                                [ngClass]="{'borderRed':news.isEmptySubCategory && news.isSubmitted}"
                                (blur)="validateNewsForm()">
            </kendo-dropdownlist>
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{news.uploadLbl}}
            </label>
            <!--<input type="file" formControlName="fileUpload" class="k-button btn kendoInput" name="fileupload"
            (change)="handleFileInput($event.target.files)" [ngClass]="{'borderRed':news.isEmptyFile && news.isSubmitted}"
                               (blur)="validateNewsForm()" />-->
            <div class="kendoInput">
              <app-upload [multiple]="false" (fileSelect)="newsAdminSelected($event)" [uploadFolderPath]="'TempDocs'"
                          (uploadSuccess)="newsAdminUploadSuccess($event)" [fileRestrictions]="fileRestrictions"></app-upload>
            </div>
            <!--<label class="lblCls">
              {{filePath}}
            </label>-->
          </div>
          <div class="form-group">
            <label class="lblCls">
              Document Description
            </label>
            <input type="text" kendoTextBox class="kendoInput" formControlName="docDescription" [ngClass]="{'borderRed':news.isEmptyDescription && news.isSubmitted}"
                   (blur)="validateNewsForm()" />
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{news.authorLbl}}
            </label>
            <input type="text" kendoTextBox class="kendoInput" formControlName="author" [ngClass]="{'borderRed':news.isEmptyAuthor && news.isSubmitted}"
                   (blur)="validateNewsForm()" />
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{news.mailNoLbl}}
            </label>
            <input type="text" kendoTextBox class="kendoInput" formControlName="mailNumber" [ngClass]="{'borderRed':news.isEmptyMailNo && news.isSubmitted}"
                   (blur)="validateNewsForm()" />
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{news.isActiveLbl}}
            </label>
            <kendo-switch formControlName="isActive" [onLabel]="'Yes'" [offLabel]="'No'"
                          class="activeSwitchCls">
            </kendo-switch>
          </div>
        </div>
      </div>
      <div class="dialog-btn-section">
        <div class="row">
          <div class="col-sm-12 float-left">
            <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 btn-align-center">
            <div class="btn-group" role="group">
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                      (click)="toggleNewsDialog()">
                {{news.closeLbl}}
              </button> &nbsp;&nbsp;
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                      (click)="saveNewsDetails()">
                {{news.saveLbl}}<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </kendo-dialog>
</section>
<kendo-dialog title="{{gridDelete.label.confirmLbl?gridDelete.label.confirmLbl:gridDelete.label.confirmLbl}}" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    {{gridDelete.label.deleteConfirmLbl?gridDelete.label.deleteConfirmLbl:gridDelete.label.deleteConfirmLbl}}
    <b> : {{ gridItemToRemove.docDesc }}</b>?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      {{gridDelete.label.deleteNoLbl?gridDelete.label.deleteNoLbl:gridDelete.label.deleteNoLbl}}
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      {{gridDelete.label.deleteYesLbl?gridDelete.label.deleteYesLbl:gridDelete.label.deleteYesLbl}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
